<template>
  <modal @close="$emit('fechar')" class="modal-de-prorrogacao">
    <form @submit.prevent="confirmar" class="formulario">
      <h3 class="titulo titulo_medio u-margem-inferior-media">
        Prorrogar prazo para envio?
      </h3>

      <hr class="u-margem-inferior-media" />

      <p class="texto texto_medio texto_cor-cinza u-margem-inferior-media">
        {{ mensagemPrincipal }}
      </p>

      <div class="u-margem-inferior-media">
        <label class="formulario__label" for="dataDeRecebimentoDoOficio">
          Data de recebimento do ofício
          <span class="dialogo-de-situacao__obrigatorio" aria-hidden="true"
            >*</span
          >
        </label>
        <input
          id="dataDeRecebimentoDoOficio"
          v-model="dataDeRecebimentoDoOficio"
          type="date"
          :max="hoje"
          required
          class="formulario__input"
          :class="{ formulario__input_erro: erro }"
        />
        <p v-if="erro" class="formulario__mensagem formulario__mensagem_erro">
          <i
            class="far fa-exclamation-circle formulario__mensagem-icone"
            aria-hidden="true"
          ></i>
          {{ erro }}
        </p>
        <p v-else class="dialogo-de-situacao__ajuda">
          Data em que a AGEHAB recebeu o ofício solicitando a prorrogação.
        </p>
      </div>

      <div class="modal-de-prorrogacao__nova-data">
        <span class="modal-de-prorrogacao__nova-data-rotulo texto_pequeno">
          Nova data limite:
        </span>
        <span class="modal-de-prorrogacao__nova-data-valor texto_medio">
          {{ novaDataLimiteFormatada || "--" }}
        </span>
        <span
          class="dialogo-de-situacao__ajuda texto_mini"
          style="margin: 0; font-weight: 700; color: var(--cor-cinza-50)"
        >
          Novo limite do prazo após a prorrogação.
        </span>
      </div>

      <div>
        <label class="formulario__label" for="observacao">
          Observação (registrada no histórico)
        </label>
        <textarea
          id="observacao"
          v-model="observacao"
          placeholder="Descreva a movimentação para os demais setores..."
          rows="4"
          class="formulario__textarea"
        ></textarea>
      </div>

      <hr class="u-margem-superior-media u-margem-inferior-media" />

      <div class="grade__linha_alinhar-horizontal-direita formulario-button">
        <button
          type="button"
          @click="$emit('fechar')"
          class="botao botao_contorno botao_medio botao_cor-cinza u-margem-direita-pequena"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="botao botao_cor-primaria botao_medio"
          :class="{ 'is-loading': carregando }"
          :disabled="carregando"
        >
          Confirmar prorrogação
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import Modal from "../../../shared/Modal";

const MENSAGEM_PRINCIPAL_POR_ESTADO = {
  vencido:
    "A prorrogação adiciona 60 dias ao prazo de envio do dossiê e libera o protocolo do recebimento.",
  "a-vencer":
    "A prorrogação adiciona ao prazo de envio do dossiê os dias restantes e libera o protocolo de recebimento.",
};

export default {
  name: "modal-de-prorrogacao",
  components: { Modal },
  props: {
    carregando: { type: Boolean, default: false },
    estado: { type: String, default: null },
    prazoDoDossie: { type: Object, default: null },
  },
  data() {
    return {
      dataDeRecebimentoDoOficio: "",
      observacao: "",
      erro: null,
    };
  },
  computed: {
    hoje() {
      return new Date().toISOString().slice(0, 10);
    },
    mensagemPrincipal() {
      return MENSAGEM_PRINCIPAL_POR_ESTADO[this.estado] || "";
    },
    novaDataLimiteFormatada() {
      const novaDataDeVencimentoPrevista =
        this.prazoDoDossie && this.prazoDoDossie.NovaDataDeVencimentoPrevista;
      return novaDataDeVencimentoPrevista
        ? this.$tempo.formatarParaPadraoBrasileiro(novaDataDeVencimentoPrevista)
        : null;
    },
  },
  methods: {
    validar() {
      this.erro = null;

      if (!this.dataDeRecebimentoDoOficio) {
        this.erro = "Campo obrigatório";
        return false;
      }

      if (this.dataDeRecebimentoDoOficio > this.hoje) {
        this.erro = "A data não pode ser futura";
        return false;
      }

      return true;
    },
    confirmar() {
      if (!this.validar()) return;

      this.$emit("confirmar", {
        dataDeRecebimentoDoOficio: this.dataDeRecebimentoDoOficio,
        observacao: this.observacao || null,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// ModalDeProrrogacao.vue?29771be0